import { captureException } from "@sentry/core"
import { useEffect } from "react"

export const useCaptureError = (error: any) => {
  useEffect(() => {
    if (!error) return;
    console.log('error', typeof error.error)
    captureException(error?.error || error)
  }, [error])
}